import { getKycImage } from "../logic/attachments";
import { booleanSelectValue, getPath, isYes } from "../logic/paths";
import { yesNoItems } from "../options";
import SectionCard from "../ui/SectionCard";
import { ShieldIcon } from "../ui/icons";
import TextField from "../ui/fields/TextField";
import SegmentedPills from "../ui/fields/SegmentedPills";
import UploadTile from "../ui/UploadTile";
import { StepViewProps } from "./types";

export default function PEP({ state, handlers }: StepViewProps) {
  const { draft, errors, uploads, originalKyc } = state;
  const kyc = draft.kyc;
  const requiresDoc =
    isYes(getPath(kyc, "PEP.governmentWork")) ||
    isYes(getPath(kyc, "PEP.governmentRelative"));

  return (
    <SectionCard title="PEP declaration" icon={<ShieldIcon size={18} />}>
      <SegmentedPills
        label="Are you working / have you worked in a government agency or institution?"
        required
        value={booleanSelectValue(getPath(kyc, "PEP.governmentWork"))}
        options={yesNoItems}
        error={errors["PEP.governmentWork"]}
        onChange={(v) => handlers.setKycField("PEP.governmentWork", v)}
      />
      <div style={{ height: 16 }} />
      <SegmentedPills
        label="Do you have a relative who is or was an elected or appointed government official?"
        required
        value={booleanSelectValue(getPath(kyc, "PEP.governmentRelative"))}
        options={yesNoItems}
        error={errors["PEP.governmentRelative"]}
        onChange={(v) => handlers.setKycField("PEP.governmentRelative", v)}
      />

      {requiresDoc && (
        <>
          <div style={{ marginTop: 20 }}>
            <TextField
              label="Please enumerate the banks you have an account in"
              required
              value={getPath<string>(kyc, "PEP.banks")}
              error={errors["PEP.banks"]}
              onChange={(v) => handlers.setKycField("PEP.banks", v)}
            />
          </div>
          <div style={{ marginTop: 8 }}>
            <UploadTile
              label="PEP supporting document"
              required
              entry={uploads.PEPDocument}
              onFileImage={getKycImage(originalKyc, "PEPDocument")}
              error={errors.PEPDocument}
              onFile={(file) => handlers.uploadFile("PEPDocument", file)}
              onRemove={() => handlers.removeUpload("PEPDocument")}
            />
          </div>
        </>
      )}
    </SectionCard>
  );
}
